import {DateTime} from "luxon";

export class DateUtils {
  static readonly DATETIME_DEFAULT_FORMAT:string = 'dd/MM/yyyy';

  public static validarFecha(value: string): boolean {
    let fechaValida: boolean = false;
    let fechaArr = value.split("/");
    if (fechaArr && fechaArr.length == 3 && Number(fechaArr[2]) > 0) {
      let units: any = {
        month: fechaArr[1],
        day: fechaArr[0]
      };
      let dt = DateTime.fromObject(units);
      fechaValida = dt.isValid;
    }
    return fechaValida;
  }

  public static fromIsoToFormat(dateIsoString:string):string {
    const dateTime:DateTime = DateTime.fromISO(dateIsoString);
    return dateTime.toFormat('dd/MM/yyyy');
  }
}
